import LayoutPage from "../../Components/LayoutPage"
import NavLayer2 from "../../Components/NavLayer2/NavLayer2"
import HeroGuide from "../../Components/HeroGuide/HeroGuide"
import InviteInfoCard from "./Components/InviteInfoCard"
import Friends from "./Components/Friends"
import NetworkOwnerSection from "./Components/NetworkOwnerSection"

export default function InviteFriends() {
  return (
    <LayoutPage activeIndex={8} navItems={["دعوت از دوستان"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["دعوت از دوستان" , "برداشت جایزه"]} hrefs={["/invite" , "/invite/gift"]} activeIndex={0}/>
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <HeroGuide
          title="دوستات رو دعوت کن و جایزه ببر!"
          h1="ارسال دعوت نامه" h2="ثبت نام" h3="دریافت جایزه"
          icon1="inviteMail" icon2="signUp" icon3="gift"
          text1="با لینک یا کد دعوت مخصوص خود، ما را || به دوستان خود معرفی کنید" text2="منتظر بمانید تا دوستتان از طریق || شما ثبت‌نام کرده و چالش خریداری کند" text3="از هر خرید چالش توسط دوستان مبلغی || به شما هدیه داده می‌شود"
        />
        <InviteInfoCard/>
        <Friends/>
        <NetworkOwnerSection/>
      </div>
    </LayoutPage>
  )
}
